import { cdataFetch } from "src/api/cdataFetch";
import { IServiceError } from "src/models/IServiceError";

export async function setIsSetupFinished() {
  return await cdataFetch<void | IServiceError>({
    method: "PUT",
    url: "/account/setIsSetupFinished",
  });
}
